import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import MUIButton from '@material-ui/core/Button';
import style from "./ButtonBase.style";

const ButtonBase = (_ref) => {
  let {
    children,
    type,
    disabled,
    className,
    onClick
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, ["children", "type", "disabled", "className", "onClick"]);

  return ___EmotionJSX(MUIButton, _extends({
    color: type === 'inherit' ? 'inherit' : 'primary',
    disabled: disabled,
    css: style.container.base({
      type
    }),
    className: className,
    onClick: onClick
  }, otherProps), children);
};

ButtonBase.defaultProps = {
  type: 'secondary',
  disabled: false,
  className: undefined,
  onClick: undefined
};
ButtonBase.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default React.memo(ButtonBase);